export enum LineItemType {
  Component = 1,
  Fee = 2,
  Bundle = 3,
  Summary = 4,
}
